import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'primeng/button';

const _c0 = ["*"];
const _c1 = function (a0) { return { "ui-state-disabled": a0 }; };
function Inplace_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r671 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("click", function Inplace_div_1_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r671); const ctx_r670 = ɵngcc0.ɵɵnextContext(); return ctx_r670.onActivateClick($event); })("keydown", function Inplace_div_1_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r671); const ctx_r672 = ɵngcc0.ɵɵnextContext(); return ctx_r672.onKeydown($event); });
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r668 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c1, ctx_r668.disabled));
} }
function Inplace_div_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r675 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function Inplace_div_2_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r675); const ctx_r674 = ɵngcc0.ɵɵnextContext(2); return ctx_r674.onDeactivateClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r673 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r673.closeIcon);
} }
function Inplace_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtemplate(2, Inplace_div_2_button_2_Template, 1, 1, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r669 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r669.closable);
} }
const _c2 = [[["", "pInplaceDisplay", ""]], [["", "pInplaceContent", ""]]];
const _c3 = function (a1) { return { "ui-inplace ui-widget": true, "ui-inplace-closable": a1 }; };
const _c4 = ["[pInplaceDisplay]", "[pInplaceContent]"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let InplaceDisplay = class InplaceDisplay {
};
InplaceDisplay.ɵfac = function InplaceDisplay_Factory(t) { return new (t || InplaceDisplay)(); };
InplaceDisplay.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InplaceDisplay, selectors: [["p-inplaceDisplay"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function InplaceDisplay_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
let InplaceContent = class InplaceContent {
};
InplaceContent.ɵfac = function InplaceContent_Factory(t) { return new (t || InplaceContent)(); };
InplaceContent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InplaceContent, selectors: [["p-inplaceContent"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function InplaceContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
let Inplace = class Inplace {
    constructor() {
        this.closeIcon = 'pi pi-times';
        this.onActivate = new EventEmitter();
        this.onDeactivate = new EventEmitter();
    }
    onActivateClick($event) {
        if (!this.preventClick)
            this.activate(event);
    }
    onDeactivateClick(event) {
        if (!this.preventClick)
            this.deactivate(event);
    }
    activate(event) {
        if (!this.disabled) {
            this.active = true;
            this.onActivate.emit(event);
        }
    }
    deactivate(event) {
        if (!this.disabled) {
            this.active = false;
            this.hover = false;
            this.onDeactivate.emit(event);
        }
    }
    onKeydown(event) {
        if (event.which === 13) {
            this.activate(event);
            event.preventDefault();
        }
    }
};
Inplace.ɵfac = function Inplace_Factory(t) { return new (t || Inplace)(); };
Inplace.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Inplace, selectors: [["p-inplace"]], inputs: { closeIcon: "closeIcon", active: "active", closable: "closable", disabled: "disabled", preventClick: "preventClick", style: "style", styleClass: "styleClass" }, outputs: { onActivate: "onActivate", onDeactivate: "onDeactivate" }, ngContentSelectors: _c4, decls: 3, vars: 8, consts: [[3, "ngClass", "ngStyle"], ["class", "ui-inplace-display", "tabindex", "0", 3, "ngClass", "click", "keydown", 4, "ngIf"], ["class", "ui-inplace-content", 4, "ngIf"], ["tabindex", "0", 1, "ui-inplace-display", 3, "ngClass", "click", "keydown"], [1, "ui-inplace-content"], ["type", "button", "pButton", "", 3, "icon", "click", 4, "ngIf"], ["type", "button", "pButton", "", 3, "icon", "click"]], template: function Inplace_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, Inplace_div_1_Template, 2, 3, "div", 1);
        ɵngcc0.ɵɵtemplate(2, Inplace_div_2_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c3, ctx.closable))("ngStyle", ctx.style);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.active);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.active);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc1.NgIf, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input()
], Inplace.prototype, "active", void 0);
__decorate([
    Input()
], Inplace.prototype, "closable", void 0);
__decorate([
    Input()
], Inplace.prototype, "disabled", void 0);
__decorate([
    Input()
], Inplace.prototype, "preventClick", void 0);
__decorate([
    Input()
], Inplace.prototype, "style", void 0);
__decorate([
    Input()
], Inplace.prototype, "styleClass", void 0);
__decorate([
    Input()
], Inplace.prototype, "closeIcon", void 0);
__decorate([
    Output()
], Inplace.prototype, "onActivate", void 0);
__decorate([
    Output()
], Inplace.prototype, "onDeactivate", void 0);
let InplaceModule = class InplaceModule {
};
InplaceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: InplaceModule });
InplaceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function InplaceModule_Factory(t) { return new (t || InplaceModule)(); }, imports: [[CommonModule, ButtonModule],
        ButtonModule] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InplaceDisplay, [{
        type: Component,
        args: [{
                selector: 'p-inplaceDisplay',
                template: '<ng-content></ng-content>'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InplaceContent, [{
        type: Component,
        args: [{
                selector: 'p-inplaceContent',
                template: '<ng-content></ng-content>'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Inplace, [{
        type: Component,
        args: [{
                selector: 'p-inplace',
                template: `
        <div [ngClass]="{'ui-inplace ui-widget': true, 'ui-inplace-closable': closable}" [ngStyle]="style" [class]="styleClass">
            <div class="ui-inplace-display" (click)="onActivateClick($event)" tabindex="0" (keydown)="onKeydown($event)"   
                [ngClass]="{'ui-state-disabled':disabled}" *ngIf="!active">
                <ng-content select="[pInplaceDisplay]"></ng-content>
            </div>
            <div class="ui-inplace-content" *ngIf="active">
                <ng-content select="[pInplaceContent]"></ng-content>
                <button type="button" [icon]="closeIcon" pButton (click)="onDeactivateClick($event)" *ngIf="closable"></button>
            </div>
        </div>
    `,
                changeDetection: ChangeDetectionStrategy.Default
            }]
    }], function () { return []; }, { closeIcon: [{
            type: Input
        }], onActivate: [{
            type: Output
        }], onDeactivate: [{
            type: Output
        }], active: [{
            type: Input
        }], closable: [{
            type: Input
        }], disabled: [{
            type: Input
        }], preventClick: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InplaceModule, { declarations: function () { return [Inplace,
        InplaceDisplay,
        InplaceContent]; }, imports: function () { return [CommonModule, ButtonModule]; }, exports: function () { return [Inplace,
        InplaceDisplay,
        InplaceContent,
        ButtonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InplaceModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ButtonModule],
                exports: [Inplace, InplaceDisplay, InplaceContent, ButtonModule],
                declarations: [Inplace, InplaceDisplay, InplaceContent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Inplace, InplaceContent, InplaceDisplay, InplaceModule };

//# sourceMappingURL=primeng-inplace.js.map